<template>
  <div class="post__user">

    <template v-if="withHeading">
        <div class="post__aside-heading">
            Автор
        </div>
    </template>

    <div class="post__user-body d-flex flex-column align-items-center px-2 pt-3">
        <a :href="profile" class="rounded-circle overflow-hidden mb-3">
            <img :src="avatar" alt="">
        </a>
        <div v-text="name" class="mb-1"></div>
        <div class="mb-4 post__user-text"><span>На сайте с: </span>{{ createdAt }}</div>
        <a class="btn" href="">Профиль</a>   
    </div>

  </div>
</template>

<script>
export default {
    name: "PostUser",
    props: {
        user: { required: true, type: Object },
        withHeading: { required: false, default: true }
    },

    computed: {
        createdAt(){
            return ((this.user.created_at.split('T'))[0]).split('-').reverse().join('.')
        },
        name(){
            return this.user.name
        },
        profile(){
            const { id }  = this.user    
            return `/user/${id}/profile`
        },
        avatar(){
            let { path } = this.user.avatar
            return `/storage/${path.replace('original', 'avatar')}`
        }
    }

}
</script>